export default "__VITE_ASSET__0edf5d19__"